import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { store } from '../app/store';
import { logout, sessionRefreshed } from '../features/auth/slice';
import { MainLayout } from '../components/layout/MainLayout';
import { DashboardPage } from '../features/dashboard/DashboardPage';
import { isTokenValid, refreshOAuthTokens } from '../services/tokenService.ts';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ location }) => {
    const state = store.getState();
    const isAuthenticated = state.auth.isAuthenticated;

    if (isAuthenticated && !isTokenValid()) {
      try {
        const tokenResponse = await refreshOAuthTokens();
        store.dispatch(
          sessionRefreshed({
            accessToken: tokenResponse.access_token,
            homePageUrl: tokenResponse.home_page_url,
            logoPageUrl: tokenResponse.logo_page_url,
          })
        );
      } catch {
        store.dispatch(logout());
        throw redirect({ to: '/login', search: { redirect: location.href } });
      }
    }

    if (!isAuthenticated) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  validateSearch: z.object({ nodeKey: z.string().optional() }),
  component: RootDashboard,
});

function RootDashboard() {
  return (
    <MainLayout>
      <DashboardPage />
    </MainLayout>
  );
}
